module.exports.array = {"Subject: Topics" : 11, 
"Subject: persons": 13, 
"Subject: places": 14,
"Author": 15,
"Place of publication": 16,
"Publisher": 17,
"Date of Publication": 18,
"Language": 19,
"Technical Name": 20, 
"classification": 21,
};

// module.exports.array = {"Subject: Topics" : 11, 



//////////////////
// WEBPACK FOOTER
// ./js/facetIndex.js
// module id = 7
// module chunks = 0